import styled from 'styled-components'
import { Row } from 'react-bootstrap'

const PageSection = styled(Row)`
  padding: 20px 20px 10px 0px;
`

export default PageSection
